import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'
import Apply from '../views/Apply.vue'
import Portfolio from '../views/Portfolio.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home
  },
  {
    path: '/Apply',
    name: 'Apply',
    component: Apply
  },
  {
    path: '/Portfolio',
    name: 'Portfolio',
    component: Portfolio
  },
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router
